import {
  FilterAutocompleteItem,
  FilterDateRangeItem, FilterSelectItem,
  FilterTextItem, GUID_FILTER,
} from '../../../model/filter';
import { AutocompleteService } from '../../../api/autocomplete.service';
import { useOptions } from '../../../hooks/UseOptions';
import { DocumentStatusEnum } from '../../../model';
import { EntityQueryKey } from '../../../query/query.keys';

export function useFilter() {
  const statusOptions = useOptions(DocumentStatusEnum, 'document:status.')
  return [
    new FilterDateRangeItem({
      field: 'createDate',
      labelKey: 'common:field.createDate',
    }),
    new FilterDateRangeItem({
      field: 'updateDate',
      labelKey: 'common:field.updateDate',
    }),
    GUID_FILTER,
    new FilterTextItem({
      field: 'search',
      labelKey: 'document:field.title',
    }),
    new FilterSelectItem({
      field: 'status',
      labelKey: 'document:field.status',
      options: statusOptions,
    }),
    new FilterAutocompleteItem({
      field: 'owner',
      labelKey: 'document:field.owner',
      fetch: AutocompleteService.fetchFn,
      queryKey: EntityQueryKey.Employee,
    }),
    new FilterAutocompleteItem({
      field: 'client',
      labelKey: 'document:field.client',
      fetch: AutocompleteService.fetchFn,
      queryKey: EntityQueryKey.Client,
    }),
  ];
}
